// extracted by mini-css-extract-plugin
export var arrow = "ShareButton-module--arrow--bf972";
export var arrowNo = "ShareButton-module--arrow_no--13dd4";
export var arrowYes = "ShareButton-module--arrow_yes--d226f";
export var flex = "ShareButton-module--flex--30417";
export var flex1 = "ShareButton-module--flex_1--44fb0";
export var flexCenter = "ShareButton-module--flex_center--78591";
export var flexCenterCol = "ShareButton-module--flex_center_col--167dc";
export var flexCol = "ShareButton-module--flex_col--fe793";
export var flexFixCenterCol = "ShareButton-module--flex_fix_center_col--f8924";
export var flexFixedCenterCol = "ShareButton-module--flex_fixed_center_col--27929";
export var rotating = "ShareButton-module--rotating--3bf95";
export var shareButtonContainer = "ShareButton-module--shareButtonContainer--3f0e6";
export var shareIcon = "ShareButton-module--shareIcon--8ba8c";
export var underlined = "ShareButton-module--underlined--a5052";